import type { FC, ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material';
import { Box, Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

export type WidgetFooterLegendLabel = {
  name: ReactNode;
  color: string;
  comparisonColor?: string;
  customBackgroundSx?: SxProps<Theme>;
};

interface WidgetFooterLegendProps {
  labels: WidgetFooterLegendLabel[];
}

const WidgetFooterLegend: FC<WidgetFooterLegendProps> = ({ labels }) => (
  <Box sx={styles.footer}>
    {labels.map(({ name, comparisonColor, color, customBackgroundSx }) => (
      <Stack
        key={typeof name === 'string' ? name : color}
        direction="row"
        sx={{
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Box
          // filter
          sx={[
            { backgroundColor: color },
            ...(Array.isArray(customBackgroundSx)
              ? customBackgroundSx
              : [customBackgroundSx]),
            styles.footerCircle,
          ].filter(Boolean)}
        />
        {comparisonColor && (
          <Box
            sx={{
              backgroundColor: comparisonColor,
              ...styles.footerCircle,
            }}
          />
        )}
        <Typography
          variant="body3"
          sx={{
            fontWeight: 600,
          }}
        >
          {name}
        </Typography>
      </Stack>
    ))}
  </Box>
);

export default WidgetFooterLegend;
